import { ServerResponse } from '../serverResponse';

export class FinnOccupation extends ServerResponse {
  // Occupations on Finn.no advertisements always has a general category, i.e. "Engineer"
  // A specialization for a category is optional, i.e. "Engineer - Electronics"

  public name: string;
  public general: string;
  public specialization: string;

  constructor(general: string, specialization: string) {
    super();
    this.general = general;
    this.specialization = specialization;
  }
}
